import { useCallback, useEffect, useState } from 'react';

import {
  fetchTraining,
  type TrainingView,
} from 'features/courier-training/services/courierTrainingService';
import { hasCompletedAllTrainingVideos } from 'features/courier-portal/utils/trainingProgress';

interface UseTrainingStatus {
  training: TrainingView | null;
  loading: boolean;
  allVideosCompleted: boolean;
  refresh: () => Promise<void>;
}

export const useTrainingStatus = (): UseTrainingStatus => {
  const [training, setTraining] = useState<TrainingView | null>(null);
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    setLoading(true);
    try {
      setTraining(await fetchTraining());
    } catch {
      // Training is optional and locked until the courier reaches the
      // TRAINING stage, so a failure here is not an error state.
      setTraining(null);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    refresh();
  }, [refresh]);

  const allVideosCompleted = hasCompletedAllTrainingVideos(training);

  return { training, loading, allVideosCompleted, refresh };
};
